module.exports = __webpack_public_path__ + "static/media/AU.77c58d2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AU.svg
// module id = 194
// module chunks = 0